import * as React from 'react';

import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export interface NeighborhoodProps {
  neighborhood?: string;
}

export const Neighborhood: React.FunctionComponent<NeighborhoodProps> = ({ neighborhood }) => {
  if (!neighborhood) {
    return null;
  }

  return (
    <UitkSpacing padding={{ blockend: 'two' }}>
      <UitkText dataTestId="content-hotel-neighborhood" overflow="wrap" theme="default">
        {neighborhood}
      </UitkText>
    </UitkSpacing>
  );
};
Neighborhood.displayName = 'Neighborhood';
